import { Link } from "react-router-dom"
import baguette from "../../assets/images/photos/baguette.jpg";
import trigo from "../../assets/images/photos/trigo.jpeg";
import molde from "../../assets/images/photos/molde.jpeg";
import blog1 from "../../assets/images/photos/Blog1.jpg";
import blog2 from "../../assets/images/photos/Blog2.jpg";
import blog3 from "../../assets/images/photos/Blog3.jpg";
import { Header } from "../../components/atoms/Header";

const posts = [
    {
        title: 'Pan de molde',
        href: '/blog/1',
        category: { name: 'Artículo', href: '#' },
        description:
            "El pan de molde es una opción que nunca falla. Con su  corteza crujiente y su interior suave y tierno, es una elección perfecta para el desayuno, el almuerzo y la cena. Además, es una alternativa versátil que se puede consumir en una amplia variedad de formas, desde tostadas hasta sandwichs y bocadillos. El pan de molde ha sido un ingrediente clave en la dieta de la mayoría de las personas por siglos.",
        date: '13 de Febrero de 2023',
        datetime: '2020-03-16',
        imageUrl:
            molde,
        readingTime: '6 min',
        author: {
            name: 'Juan Marin',
            href: '#',
            imageUrl:
                blog1
        },
    },
    {
        title: 'El pan hamburguesa: El compañero...',
        href: '/blog/2',
        category: { name: 'Artículo', href: '#' },
        description:
            'El pan hamburguesa: Un ingrediente clave para el éxito de cualquier comida rápida. El pan hamburguesa es un elemento clave en cualquier comida rápida.No solo es un ingrediente versátil que se puede adaptar a cualquier sabor y textura, sino que también es un elemento esencial para el equilibrio y la consistencia de una hamburguesa',
        date: '10 de Febrero de 2023',
        datetime: '2020-03-10',
        imageUrl:
            trigo,
        readingTime: '4 min',
        author: {
            name: 'Julio Alvarez',
            href: '#',
            imageUrl:
                blog2
        },
    },
    {
        title: 'El pan Baguette: Un clásico de la ...',
        href: '/blog/3',
        category: { name: 'Artículo', href: '#' },
        description:
            'El pan Baguette es uno de los tipos de pan más reconocidos y apreciados en todo el mundo. Con su forma característica y su corteza crujiente, este pan se ha convertido en un clásico de la panadería francesa y es un elemento esencial en la cocina gourmet. El pan Baguette se originó en Francia en el siglo XVIII y se ha vuelto muy popular en todo el mundo desde entonces. Se caracteriza por su forma alargada y su',
        date: '12 de Febrero de 2023',
        datetime: '2020-02-12',
        imageUrl: baguette,
        readingTime: '11 min',
        author: {
            name: 'Gretel Otero',
            href: '#',
            imageUrl:
                blog3
        },
    },
]

export default function BlogList() {
    return (
        <>
            <Header />
        <div className="relative bg-gray-50 dark:bg-zinc-800 px-6 pt-16 pb-20 lg:px-8 lg:pt-24 lg:pb-28">
            <div className="absolute inset-0">
                <div className="h-1/3 bg-white dark:bg-zinc-800 sm:h-2/3" />
            </div>
            <div className="relative mx-auto max-w-7xl">
                <div className="text-center">
                    <h2 className="text-3xl font-bold tracking-tight dark:text-white text-gray-900 sm:text-4xl">"El Sabor y la Belleza del Pan: Una Historia sin Fin"</h2>
                    <p className="mx-auto mt-3 max-w-2xl text-xl dark:text-white text-gray-900 sm:mt-4">
                        "Pan fresco, corazón caliente: la tradición de la panadería vive en cada bocado."
                    </p>
                </div>
                <div className="mx-auto mt-12 grid max-w-lg gap-5 lg:max-w-none lg:grid-cols-3">
                    {posts.map((post) => (
                        <div key={post.title} className="flex flex-col overflow-hidden rounded-lg shadow-lg">
                            <div className="flex-shrink-0">
                                <img className="h-48 w-full object-cover" src={post.imageUrl} alt="" />
                            </div>
                            <div className="flex flex-1 flex-col justify-between bg-white dark:bg-zinc-700 p-6">
                                <div className="flex-1">
                                    <p style={{ color: "#b64e30" }} className="text-sm font-medium text-indigo-600">
                                        <Link to={post.href} className="hover:underline">
                                            {post.category.name}
                                        </Link>
                                    </p>
                                    <Link to={post.href} className="mt-2 block">
                                        <p className="text-xl font-semibold dark:text-white text-gray-900">{post.title}</p>
                                        <p className="mt-3 text-base text-left text-gray-500 dark:text-white">{post.description}</p>
                                    </Link>
                                </div>
                                <div className="mt-6 flex items-center">
                                    <div className="flex-shrink-0">
                                        <a href={post.author.href}>
                                            <span className="sr-only">{post.author.name}</span>
                                            <img className="h-10 w-10 rounded-full" src={post.author.imageUrl} alt="" />
                                        </a>
                                    </div>
                                    <div className="ml-3">
                                        <p className="text-sm font-medium text-gray-900">
                                            {post.author.name}
                                        </p>
                                        <div className="flex space-x-1 text-sm dark:text-white text-gray-500">
                                            <time dateTime={post.datetime}>{post.date}</time>
                                            <span aria-hidden="true">&middot;</span>
                                            <span>{post.readingTime} read</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            </div>
            </>
    )
}
